// extracted by mini-css-extract-plugin
export default {"printButton":"PrintButton_printButton__XBa64"};